import { render, staticRenderFns } from "./SignMsgList.vue?vue&type=template&id=02197566&scoped=true&"
import script from "./SignMsgList.vue?vue&type=script&lang=js&"
export * from "./SignMsgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02197566",
  null
  
)

export default component.exports